import { Routes } from '@angular/router';

import { microsoftServicesSegments } from '@advania-cosoftware/wolf-router';

export const microsoftServicesRoutes: Routes = [
    {
        path: microsoftServicesSegments.microsoftServices,
        loadComponent: () =>
            import('./pages/microsoft-services-tab-page/microsoft-services-tab.page').then(
                (m) => m.MicrosoftServicesTabPage,
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: microsoftServicesSegments.statuses,
            },
            {
                path: `${microsoftServicesSegments.statuses}/:serviceHealthId`,
                loadComponent: () =>
                    import('./pages/statuses/microsoft-services-status-page/microsoft-services-status.page').then(
                        (m) => m.MicrosoftServicesStatusPage,
                    ),
            },
            {
                path: microsoftServicesSegments.statuses,
                loadComponent: () =>
                    import('./pages/statuses/microsoft-services-statuses-page/microsoft-services-statuses.page').then(
                        (m) => m.MicrosoftServicesStatusesPage,
                    ),
            },
            {
                path: `${microsoftServicesSegments.messages}/:serviceMessageId`,
                loadComponent: () =>
                    import('./pages/messages/microsoft-services-message-page/microsoft-services-message.page').then(
                        (m) => m.MicrosoftServicesMessagePage,
                    ),
            },
            {
                path: microsoftServicesSegments.messages,
                loadComponent: () =>
                    import('./pages/messages/microsoft-services-messages-page/microsoft-services-messages.page').then(
                        (m) => m.MicrosoftServicesMessagesPage,
                    ),
            },
        ],
    },
];
